import {
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import { SimulabCoachee } from "@/entities/simulab"
import Avatar from "@/shared/avatar/Avatar"

import { SimulabCoachingIntroCard } from "./SimulabCoachingIntroCard"

type Props = {
    coachee: SimulabCoachee
    showButton: boolean
    onButtonClick: () => void
}

export const SimulabChatHeader = ({ coachee, showButton, onButtonClick }: Props) => {
    return (
        <div className="simulab-chat-header">
            <div className="d-flex align-items-center mb-3">
                <Avatar url={coachee.photo} width={40} height={40} className="mr-3" />
                <Typography
                    className="m-0"
                    text={coachee.name}
                    size={ETypographySize.Heading2}
                    alignment={ETypographyAlignment.Left}
                    family={ETypographyFamily.DmSerif}
                    weight={ETypographyWeight.Medium}
                    color={ETypographyColor.Black}
                    tag={ETypographyTag.Heading3}
                />
            </div>
            <SimulabCoachingIntroCard coachee={coachee} showButton={showButton} onButtonClick={onButtonClick} />
        </div>
    )
}
